export const MenuTypes = {
    SelfieSetup: 1,
    OptimaMain: 2,
    OptimaSetup: 3,
    OptimaSilverbyte: 4 ,
    OptimaReports: 5
}